/* Login */
import LoginDentalPro from "./idp/LoginDentalPro.vue";
import LoginNew from "./LoginNew.vue";

export const loginRouting = {
  path: "/login",
  name: "Login",
  component: LoginNew,
  meta: {
    layout: "Restricted"
  }
};

export const loginDentalProRouting = {
  path: "/dental-pro/login",
  name: "LoginDentalPro",
  component: LoginDentalPro,
  meta: {
    layout: "Restricted"
  }
};
